import { gsap } from "gsap";

export default class AiRevolutionHeroSVG {
    static init() {
        const heroAnimationEl = document.querySelector('[data-animation-revolution="moving-shapes-01"]');
        if (!heroAnimationEl) return;

        new AiRevolutionHeroSVG(heroAnimationEl);
    }

    constructor(el) {
        if (this.isMobile()) return;
        this.el = el;
        this.svg = el.querySelector('svg');
        this.sizes = {};
        this.setSizes();
        this.initObjects();
        this.initAnimations();
    }

    isMobile() {
        return window.matchMedia("(max-width: 767px)").matches
    }

    setSizes() {
        this.sizes.width = this.el.clientWidth;
        this.sizes.height = this.el.clientHeight;
        this.sizes.aspect = this.sizes.width / this.sizes.height;
        this.sizes.dpi = Math.min(window.devicePixelRatio, 2);
    }

    initObjects() {
        this.animationSpeed = this.el.getAttribute('data-animation-speed') || 1;

        this.objectBackground = this.svg.querySelector('#ai-revolution-object-bg');
        this.object2 = this.svg.querySelector('#ai-revolution-object-2');
        this.object3 = this.svg.querySelector('#ai-revolution-object-3');
        this.object4 = this.svg.querySelector('#ai-revolution-object-4');
        this.object5 = this.svg.querySelector('#ai-revolution-object-5');

        gsap.set(this.object3, { transformOrigin: 'top 140%' });
        gsap.set(this.object4, { transformOrigin: 'top 140%' });

        gsap.set(this.objectBackground, { transformOrigin: 'center' });
        gsap.set(this.object2, { transformOrigin: 'top left' });
        gsap.set(this.object5, { transformOrigin: 'top left' });
    }

    initAnimations() {
        this.timeline = gsap.timeline({
            repeat: -1,
        });

        this.timeline
            .addLabel('start')
            .addLabel('checkpoint0', 10)
            .to(this.objectBackground, {
                duration: 20,
                rotation: 90,
                scaleY: 1.87,
                ease: 'none',
            }, 'start')
            .to(this.objectBackground, {
                duration: 85,
                scaleY: 1,
                rotation: 360,
                ease: 'none',
            })

            .fromTo(this.object2, {
                    rotation: 0,
                    alpha: 1,
                },{
                    duration: 105,
                    rotation: 40,
                    alpha: 0,
                    ease: 'none',
            }, 'start')

            .fromTo(this.object5, {
                    rotation: -55,
                    alpha: 0,
                },{
                    duration: 105,
                    rotation: 0,
                    alpha: 1,
                    ease: 'none',
            }, 'checkpoint0')

            .fromTo(this.object3, {
                rotation: 0,
                alpha: 1,
            },{
                duration: 105,
                rotation: 53,
                alpha: 0,
                ease: 'none',
            }, 'start')

            .fromTo(this.object4, {
                rotation: -50,
                alpha: 0,
                scale: 1.6,
                // x: 500,
                // y: 1000,
            },{
                duration: 105,
                rotation: 0,
                alpha: 1,
                scale: 1,
                // x: 0,
                // y: 0,
                ease: 'none',
            }, 'checkpoint0')

        if(this.animationSpeed !== 1) {
            this.timeline.timeScale(this.animationSpeed);
        }
    }
}
